import React from 'react'
import Script from 'next/script'
import { SuccessPage } from 'components'

export default function NDSuccess() {
  return (
    <>
      <noscript>
        <img
          alt="nextdoor"
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://flask.nextdoor.com/pixel?pid=7e46c2e4-dae2-4a89-b799-e50e312186a3&ev=CONVERSION&noscript=1"
        />
      </noscript>
      <Script
        id="nextdoor"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          (function(win, doc, sdk_url){
            if(win.ndp) return;
            var tr=win.ndp=function(){
            tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
          };
            tr.queue = [];
            var s='script';
            var new_script_section=doc.createElement(s);
            new_script_section.async=!0;
            new_script_section.src=sdk_url;
            var insert_pos=doc.getElementsByTagName(s)[0];
            insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
          })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');

            ndp('init','7e46c2e4-dae2-4a89-b799-e50e312186a3', {})
            ndp('track','CONVERSION');

    `,
        }}
      />

      <SuccessPage />
    </>
  )
}
